import React from 'react'
import { useNavigate } from 'react-router';
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MdArrowForward } from "react-icons/md";
import CargoNotif from "../../../home/images/cargoNotif.png";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { CiHeart } from "react-icons/ci";
import {FaHeart} from "react-icons/fa";
import CargoService from '../../../../services/Cargo';
import { timeAgo,gregorianToJalali } from '../../../../utiels/functions/persianFormat';

export default function Fcard({ cargos }) {
    const [isMobile, setIsMobile] = useState(false);
    const [showAll, setShowAll] = useState(false);

  console.log(cargos)
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);





    return (




            <div className="grid w-full gap-6 grid-cols-1 pb-5   max-h-full overflow-y-auto sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
                {cargos.map((cargo, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.06 }}
                        className="w-full h-max"
                    >
                        <CardCargoInfo
                          typeOfCar={(cargo?.car?.label || "") + "-" +(cargo?.car?.name|| "" )}
                             timeOfCargo={cargo.deliveryDate}
                             timeOfCreate={cargo.createdAt}
                             origin={(cargo.origin?.state?.name || cargo.origin?.country?.name) + "," +cargo.origin?.name }
                             dest={(cargo.destination?.state?.name || cargo.destination?.country?.name) + "," +cargo.destination?.name }
                             id={cargo._id}
                             isSaved={cargo?.isSaved}
                        />
                    </motion.div>
                ))}
            </div>





    );
}


function CardCargoInfo({ typeOfCar, timeOfCargo, timeOfCreate, origin, dest,id ,isSaved}) {
    const [isLike,setIsLike]=useState(true)
    const navigate=useNavigate()
    const [role,setRole]=useState("user")
  
  
    function handleOnCardClick(id){
      navigate(`/cargo/${id}`)
    }
  
    async function handleLikeCargo(){
      if(isLike){
        setIsLike(prev=>!prev)
  
        try{
          const body={
            "cargoId": id,
            "type": role
          }
          const res=await CargoService.disLikeCargo(body)
          
        }catch(err){
    
          setIsLike(false)
        }
  
  
  
      }else{
        setIsLike(prev=>!prev)
        try{
          const body={
            "cargoId": id,
            "type": role
          }
          const res=await CargoService.likeCargo(body)
        
        }catch(err){
    
          setIsLike(false)
        }
  
      }
     
  
  
    }
  
  
  
    return (
      <div className="rounded-[30px] hover:translate-y-1 transition duration-200 text-special 
        w-full  bg-white border-[1px] border-gray-200  h-max  
        shadow-md flex flex-col justify-between items-center 
        px-1 py-4 ">
        
        {/* header */}
        <div className="flex justify-between w-full h-max lg:px-8 px-5">
          <div className="flex flex-row gap-4 items-center text-gray-900 w-auto">
            <img className="w-[40px]" src={CargoNotif} />
            <p className="lg:text-[16px] text-[14px]">{typeOfCar}</p>
            
          </div>
  
          <div className="flex flex-row gap-2 w-auto overflow-hidden  items-center">
            <div className="text-center rounded-lg w-[80px] h-[20px] py-1 bg-[#0075FF0D]">
              <p className="text-blue-950 lg:text-[12px] text-[10px]"> {timeAgo( timeOfCreate)}</p>
            </div>
            <div onClick={handleLikeCargo} className="w-auot h-auto">
            {
              isLike?
              <FaHeart  size={20} className="text-special"></FaHeart>
              :
              <CiHeart  size={20} className="text-special"></CiHeart>
  
  
            }
  
            </div>
         
           
          </div>
        
        </div>
  
        {/* body */}
        <div className="h-1/3 flex flex-col w-full justify-center items-center lg:py-7 py-4  lg:px-8 px-5 ">
  
          <div className="flex flex-col items-start justify-center  text-start  w-full ">
  
            <p className='lg:text-[16px] text-[14px] text-gray-400'>مبدا: {origin}</p>
            <p className='lg:text-[16px] text-[14px] text-gray-400'>مقصد: {dest}</p>
            <p className='lg:text-[16px] text-[14px] text-gray-400'>بارگیری: {gregorianToJalali( timeOfCargo)}</p>
    
  
  
          </div>
        </div>
  
        <div className="w-full px-5">
          <button onClick={()=>{handleOnCardClick(id)}}  className={`w-full whitespace-nowrap  lg:text-[16px] text-[14px]  rounded-[12px] lg:1/4 h-[40px] bg-white  text-special hover:text-white hover:bg-special border-[1px] border-special text-center lg:px-10 py-2`}>
           نمایش جزییات بیشتر
          </button>
        </div>
      </div>
    );
  }
  
